import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Alert from 'components/Alert';

class ErrorBoundary extends Component {
  static propTypes = {
    alert: PropTypes.element,
    style: PropTypes.object,
    children: PropTypes.element.isRequired,
  };

  static defaultProps = {
    alert: null,
    style: {},
  };

  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    });
  }

  render() {
    const {
      alert,
      style,
      children,
    } = this.props;

    const {
      hasError,
    } = this.state;

    if (hasError) {
      if (alert) {
        return alert;
      }

      return (
        <Alert
          type='error'
          title='Ett fel har uppstått!'
          style={style}
        />
      );
    }

    return children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.jsx